// App.js
import React, { createContext, useState } from 'react';
// import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { HashRouter as Router, Route, Routes,Navigate  } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './component/Home';
import Undermaintenance from './component/undermaintenance';
import Master from './component/master/master';
import Ordering from './component/Ordering/Ordering';
import  CorporateCell from './component/CorporateCell/Corporate_Cell';
import  Corporate from './component/CorporateCell/CorporateCell';
import Dealer from './component/Dealer/Dealer';
import Reports from './component/Reports/Reports';
import Services from './component/services/services';
import SalesandDistribution from './component/SalesandDistribution/Sales_and_Distribution';
import Header from './component/Reusable/heading';
import BreadcrumbItem from './component/Reusable/BreadcrumbsContext';
import LoginPage from './component/Login';
import Glnorange from './component/master/Document_Number_Range';
import Mpoconfiguration from './component/master/Mpo_configuration';
import Functions from './component/master/Function_Approval_Settings';
import UserCreateTable from './component/master/User_Creation';
import MPO_Date_Control from './component/master/MPO_Date_Control.js';
import RCP_Price_List from './component/Dealer/RCP_Price_List';
import Orderingprocess from './component/Ordering/Purchase_Order_Create';
import POdetails from './component/Ordering/Purchase_Order_Amend';
import  RealTimeInfo from './component/Dealer/Real_Time_Info';
import  BalanceConfirmationLetter from './component/Dealer/Balance_Confirmation_Letter';
import  DealerType from './component/Dealer/DealerType';
import SisoHome from './component/siso/siso'
import ProductSelection from './component/siso/ProductSelection'
import SisoIndex from './component/siso/Spares_Identification_Software'
import ProductDetails from './component/siso/ProductDetails'
import ProductDetails_INLUDE from './component/SISO_INCLUDE/ProductDetails_INCLUDE.js'
import SISO_INCLUDE from './component/SISO_INCLUDE/SISO_INCLUDE.js'
import SISO_EXCELUPLOAD from './component/siso/ExcelUpload.js'
import SISO_ImageStatusUpdate from './component/siso/ImageStatusUpdate.js'
import SISO_EXCELUPLOAD_MATERIAL from './component/siso/MaterialExcelUpload.js';
import SISO_ImageStatusUpdate_MATERIAL from './component/siso/MaterialImageStatusUpdate.js';
import Spare_XPO_Ordering from './component/Ordering/XPO_BOM_Order';
import Rcpitemconfig from './component/master/Rcppsgconfiguration'
import Rcpheadflowconfig from './component/master/Rcphpheadconfiguration'
import Place_Locator from './component/master/Place_Locator';
import ServiceClaimStatus from './component/services/serviceClaimStatus';
import SubdealerSales from './component/SalesandDistribution/Sub_dealer_Sales';
import Subdealersalesreturn from './component/SalesandDistribution/Subdealer_Sales_Return';
//import SubDealerCreation from './component/SalesandDistribution/Sub_Dealer_Creation';
import SubDealerCreation from './component/Dealer/Sub_Dealer_Creation';
import SerialNoHistory from './component/services/Serial_No_History';

import Serviceclaimpending from './component/services/service_claim_pending';
import Alert from './component/services/Service_Alert.js';
import ServiceClaimPendingValue from './component/services/service_claim_pending_claim';
import ServiceClaimRejectClaimValue from './component/services/service_claim_reject_claim';
import Defectivegoodsreceipts from './component/services/Defective_goods_receipts';
import ServiceClaimApproval from './component/services/Service_Claim_Approval.js';
import ServiceClaimBMApproval from './component/services/Service_Claim_BM_Approval.js';
import ServiceClaimGJVCreation from './component/services/Service_Claim_GJV_Creation.js';
import BalanceConfirmation from './component/Reports/Balance_Confirmation_Report.js';
import Deliverychallan from './component/services/Delivery_Challan'
import BillingClaim from './component/services/Billing_Claim'
import Accounttransaction from './component/Reports/Account_Transaction'


import ForgetPassword from './component/ForgetPassword';
import ResetPassword from './component/ResetPassword';
import CustomerEnquiry from './component/CustomerEnquiry/Customer_Enquiry';
import Tollfree from './component/CustomerEnquiry/TollFree';

import Happy_code from './component/Tools/happy_code_view.js';
import Happy_code_view from './component/Tools/happy_code_upload.js';
import Solar_Tollfree_upload from './component/Tools/tollfree_enquiry_upload.js';
import Solar_Tollfree_Installer_upload from './component/Tools/tollfree_installar_excel_upload.js';
import Solar_Installer_vs_Area_Mapping from './component/Tools/Solar_Installer_vs_Area_Mapping.js';
import Cspmdr from  './component/Dealer/CSP_DMR_NEW';
import SUBDEALERSalesReport from './component/Reports/SUB_DEALER_Sales_Report';
import DealerMapView from './component/Reports/googlemap';
import DealerRegionMapView from './component/Reports/dealer_rijen';
import DynamicReport from './component/Reports/Dynamic_Report';
import Approval from './component/Approval/Approval';
import Dealerdevelopmentplan from './component/Dealer/Dealerdevelopmentplan';
import MdpCompletion from './component/Dealer/MDP_Completion';
import MdpApproval from './component/Approval/MDP_Approval';
import ApprovedBrvDetails from './component/Reports/Approved_Brv_Details.js';
import ExWarrentyReport from './component/Reports/Ex_Warranty_Report.js';
import WindingWireReport from './component/Reports/Winding_Wire_Report.js';
import DefectivePendingReport from './component/Reports/DefectivePendingReport.js';
import SCRPendingCount from './component/Reports/SCR_Pending_Count.js';
import ASCMappingReport from './component/Reports/ASC_Mapping_Report.js';
import AccountedScrReport from './component/Reports/Accounted_SCR_Report.js';
import ScrStatusReport from './component/Reports/SCR_Status_Report.js';
import AssignExecutiveToDealer from './component/master/AssignExecutiveToDealer.js';
import DealerAchievementUpload from './component/master/Dealer_Achievement_Upload.js';
import Solar from './component/Solar/Solar';

import Solarempcreate from './component/Solar/SOLAR_PROJECT_ID';
import SolarCustomerCreation from './component/Solar/Solar_Customer_Creation.js';
import Solar_Order_creation from './component/Solar/Solar_Order_Creation.js';
import Product_Registration_Report from './component/Reports/Product_Registration_Report.js';
import Dealer_Status_Control from './component/master/Dealer_Status_Control.js';

import SCAReprot from './component/Reports/Spares_Consumed_Analysis_Report';
import Mediator_Report from './component/Reports/Mediator_Report';
import DDP_Document_Download from './component/Reports/MDP_Document_Download';
 import Spares_And_Labour_Report from './component/Reports/Spares_And_Labour_Report';
import New_SC_Report from './component/Reports/New_Sc_Report.js';
import Newserviceclaiminvoicecopy from './component/Reports/newserviceclaiminvoicecopy'
import ServiceClaimReport from './component/Reports/Service_Claim_Report.js';
import ServiceDashborde from './component/Reports/service_dashborde.js';
import ProductRegistrationStatus from './component/Reports/Product_registration_status.js';

import Rewinding_Rate_Fixation from './component/services/Rewinding_Rate_Fixation';
import Rewinding_Rate_Approval from './component/services/Rewinding_Rate_Approval';

import Bandhan_Report from './component/Reports/Bandhan_Report.js';
import Mechanic_Report from './component/Reports/Mechanic_Report.js';
import Mechanic_Report_Excel_Download from './component/Reports/Mechanic_Report_Excel_Download'; 
import Retailer_Report from './component/Reports/Retailer_Report.js';
import Retailer_Report_Excel_Download from './component/Reports/Retailer_Report_Excel_Download.js';
import Service_Call_Cancellation from './component/services/Service_Call_Cancellation.js';
import Service_Call_Cacellation_Status from './component/services/Service_Call_Cancellation_Status.js';
import Warrenty_Cancel from './component/services/Warrenty_Cancel.js';
import Warrenty_Status from './component/services/Warrenty_Status.js';
import Post_Warrenty_Status from './component/services/Post_Warrenty_Status.js';
import Service_Claim_Cancel from './component/services/Service_Claim_Cancel.js';
import Service_Claim_Ledger from './component/services/Service_Claim_ledger.js';
import Service_Call_Cancellation_Approval from './component/Approval/Service_Call_Cancellation_Approval.js';
import Asc_Segment_Config from './component/services/Asc_Segment_Config.js';
import Asc_Mapping from './component/services/Asc_Mapping.js';
import Un_Mapped_Dealers from './component/services/Un_Mapped_Dealers.js';
import Service_Claim_Audit from './component/services/Service_Claim_Audit.js';
import PGVSBG from './component/master/PSG_vs_Billing_Group_Mapping.js';
import Billing_Claim_Print from './component/services/BIlling_Claim_Print.js';
import Global_Billing_Minimum_Value_Order_Config from './component/master/Global_Billing_Minimum_Value_Order_Config.js';

import RetailerSalesOrderReport from './component/Reports/retailer_sales_order_report.js';
import BCS_Approval_Mapping from './component/Dealer/BCS_Approval_Mapping.js';


// import Digital_Library from './component/Digital_Library/Digital_Library'
// import Scheme from './component/Digital_Library/Schemes'
// import Awards from './component/Digital_Library/Awards'
// import Branding from './component/Digital_Library/Branding'
// import Product from './component/Digital_Library/Product'
// import In_House from './component/Digital_Library/In_house'

import Field_Partner from './component/FieldPartner/Field_Partner.js';
import Field_Partner_Add from './component/FieldPartner/Field_Partner_Add.js';
import Field_Partner_Report from './component/FieldPartner/Field_Partner_Report.js';
import BCS_HO_Approval from './component/Approval/BCS_HO_Approval.js';
import BcsOrderStatus from './component/Reports/BcsOrderStatus.js';
import Bcs_Winding_Config from './component/services/Bcs_Winding_Config.js';

import DealerAndSubDealerReport from './component/Reports/dealerandsubdealerreport.js';
import SchemeCreate from './component/Tools/SchemeCreate.js';

import Replacement from './component/services/ReplacementMenu.js';
import ReplacementReport from './component/Reports/ReplacementReport.js';

export const BASE_URL = 'https://mobile.cri.in/grssuitebackend/public/api';

export const BreadcrumbsContext = createContext([]);

const App = () => {
    const [breadcrumbs, setBreadcrumbs] = useState([]);

    return (
        <div>
          
            <Router basename="/">
                {/* <Defectivegoodsreceipts/> */}

       <BreadcrumbsContext.Provider value={breadcrumbs} style={{ color: 'red' }}>
                    <div>
                        <Header />
                        <BreadcrumbItem />
                        <Routes>
                      
                            <Route path="/" element={<LoginPage />} />
                           
                            <Route path="/Login" element={<LoginPage />} />
							<Route path="/Forgot_Password" element={<ForgetPassword />} />
                            <Route path="/Reset_Password" element={<ResetPassword />} />
                            <Route path="/home" element={<Home />} />
                            <Route path="/Home/master" element={<Master />} />
                            <Route path="/Home/services" element={<Services />} />
                            <Route path="/Home/Sales_and_Distribution" element={<SalesandDistribution />} />
                            <Route path="/Home/Spares/" element={<SisoHome />} />
                            <Route path="/Home/Ordering/" element={<Ordering />} />
                            <Route path="/Home/Dealer" element={<Dealer />} />
                            <Route path="/Home/Reports/" element={<Reports />} />
                            <Route path="/Home/Request" element={<Undermaintenance />} />
                             <Route path="/Home/Approval" element={<Approval />} />
                            <Route path="/Home/Write_Us" element={<Undermaintenance />} />
							<Route path="/Home/Tools" element={<Happy_code />} />
							<Route path="/Home/Tools/Upload" element={<Happy_code_view />} />
							<Route path="/Home/Tools/TollfreeUpload" element={<Solar_Tollfree_upload />} />
							<Route path="/Home/Tools/Tollfree_Installer_Upload" element={<Solar_Tollfree_Installer_upload />} />
							<Route path="/Home/Tools/Solar_Installer_Vs_Area_Mapping" element={<Solar_Installer_vs_Area_Mapping />} />
                             <Route path="/Home/Solar" element={<Solar/>} />
                            <Route path="/Home/Product_Complaint_Register" element={<Undermaintenance />} />
                            <Route path="/Home/Fore_Cast" element={<Undermaintenance />} />
                            <Route path="/Home/E-Shop" element={<Undermaintenance />} />

                            <Route path="/Home/master/Document_Number_Range" element={<Glnorange />} />
                            <Route path="/Home/master/Mpo_configuration" element={<Mpoconfiguration />} />
                            <Route path="/Home/master/Function_Approval_Settings" element={<Functions />} />
                            <Route path="/Home/master/User_Creation" element={<UserCreateTable />} />
                            <Route path="/Home/master/Place_Locator" element={<Place_Locator />} />
                            <Route path="/Home/master/RCP_ITEM_CONFIGURATION" element={<Rcpitemconfig />} />
                            <Route path="/Home/master/RCP_HEAD_FLOW_CONFIGURATION" element={<Rcpheadflowconfig />} />
                            <Route path="/Home/master/MPO_Date_Control" element={<MPO_Date_Control />} />
                            {/* <Route path="/" element={<MPO_Date_Control />} /> */}
                            <Route path="/Home/Dealer/RCP_Price_List" element={<RCP_Price_List />} />
                            <Route path="/Home/Dealer/Real_Time_Info" element={<RealTimeInfo />} />
                            <Route path="/Home/Dealer/Balance_Confirmation_Letter" element={<BalanceConfirmationLetter />} /> 
                            <Route path="/Home/Dealer/Select_Dealer" element={<DealerType />} />
							<Route path="/Home/Dealer/CSP_DMR" element={<Cspmdr />} />
							
                           <Route path="/Home/Dealer/Field_Partner" element={<Field_Partner/>}/>
                           <Route path="/Home/Dealer/Field_Partner_Add" element={<Field_Partner_Add/>}/>
                            <Route path="/Home/Dealer/Field_Partner_Report" element={<Field_Partner_Report/>}/>
							
                            <Route path="/Home/Corporate_Cell/" element={<CorporateCell />} />
			                <Route path="/Home/Corporate_Cell/Corporate_Cell" element={<Corporate />} />
                            <Route path="/Home/Ordering/Purchase_Order_Create" element={<Orderingprocess />} /> 
                            <Route path="/Home/Ordering/Purchase_Order_Amend" element={<POdetails />} />
                       <Route path="/Home/Ordering/Spares_XPO_Ordering" element={<Spare_XPO_Ordering />} />
               
                             <Route path="/Home/Spares/Spares_Identification_Software" element={<SisoIndex />} />
                            <Route path="Home/Spares/product" element={<ProductSelection />} />
                            <Route path="Home/Spares/Spares_Identification_Software/spare_selection" element={<ProductDetails />} />

                            <Route path="/Home/services/service_Claim_Status" element={<ServiceClaimStatus />} />
                            <Route path="/home/services/Serial_No_History" element={<SerialNoHistory />} />
                            {/* <Route path="/home/services/service_claim" element={<Serviceclaim />} /> */}
                            <Route path="/home/services/Defective_goods_receipts" element={<Defectivegoodsreceipts />} />
                            
                            <Route path="/home/services/Delivery_Challan" element={<Deliverychallan />} />
                            <Route path="/home/services/Service_Alert" element={<Alert />} />
                            {/* <Route path="/home/services/Billing_Claim" element={<BillingClaim />} /> */}
                            <Route path="/home/services/Billing_Claim" element={<Alert />} />
							
							
                            <Route path="/home/services/service_claim_pending" element={<Serviceclaimpending />} />
                            <Route path="/home/services/service_claim_pending_claim" element={<ServiceClaimPendingValue />} />
                            <Route path="/home/services/service_claim_reject_claim" element={<ServiceClaimRejectClaimValue />} />
                            <Route path="/home/services/service_claim_approval" element={<Alert />} />
                              {/* <Route path="/home/services/service_claim_approval" element={<ServiceClaimApproval />} /> */}
                             {/* <Route path="/home/services/service_claim_approval" element={<ServiceClaimApproval />} /> */}
                            <Route path="/home/services/service_claim_bm_approval" element={<Alert />} />
                             {/* <Route path="/home/services/service_claim_bm_approval" element={<ServiceClaimBMApproval />} /> */}
                             	 <Route path="/home/services/service_claim_gjv_creation" element={<Alert />} /> 
							 <Route path="/home/services/service_claim_audit" element={<Service_Claim_Audit />} />

                            <Route path="/home/Sales_and_Distribution/Sub_dealer_Sales" element={<SubdealerSales />} />
                            <Route path="/home/Sales_and_Distribution/Subdealer_Sales_Return" element={<Subdealersalesreturn />} />
                            <Route path="/home/Dealer/Sub_Dealer_Creation" element={<SubDealerCreation />} />
                          //  <Route path="/home/Sales_and_Distribution/Sub_Dealer_Creation" element={<SubDealerCreation />} />
                                 <Route path="/home/Reports/Account_Transaction" element={<Accounttransaction />} />
        <Route path="/home/Reports/SUB_DEALER_Sales_Report" element={<SUBDEALERSalesReport />} />
		<Route path="/home/Reports/Approved_Brv_Details" element={<ApprovedBrvDetails />} /> 
                         <Route path="/home/Reports/Ex_Warranty_Report" element={<ExWarrentyReport/>}/>
                        <Route path="/home/Reports/Winding_Wire_Report" element={<WindingWireReport/>}/>
                        <Route path="/home/Reports/Defective_Pending_Report" element={<DefectivePendingReport/>}/>
                         <Route path="/home/Reports/SCR_Pending_Count" element={<SCRPendingCount/>}/>
                         <Route path="/home/Reports/ASC_Mapping_Report" element={<ASCMappingReport/>}/>
                         <Route path="/home/Reports/Accounted_SCR_Report" element={<AccountedScrReport/>}/>
                         <Route path="/home/Reports/SCR_Status_Report" element={<ScrStatusReport/>}/>
                         <Route path="/home/master/Assign_Executive_To_Dealer" element={<AssignExecutiveToDealer/>}/>
                         <Route path="/home/master/Dealer_Achievement_Upload" element={<DealerAchievementUpload/>}/>
                        
                      
               <Route path="/home/Reports/Dynamic_Report" element={<DynamicReport />} />
                            
         <Route path="/Home/Customer_Enquiry/TollFree" element={<Tollfree />} />
  <Route path="/Home/Customer_Enquiry/" element={<CustomerEnquiry />} />
  
							{/* <Route path="/home/Digital_Library/" element={<Digital_Library />} />
                            <Route path="/home/Digital_Library/Schemes_And_Concepts" element={<Scheme />} />
                            <Route path="/home/Digital_Library/Awards" element={<Awards />} />
                            <Route path="/home/Digital_Library/Branding" element={<Branding />} />
                            <Route path="/home/Digital_Library/Product" element={<Product />} />
                            <Route path="/home/Digital_Library/In_House_Magazine" element={<In_House />} /> */}
							
							<Route path="/siso" element={<SISO_INCLUDE />} /> 
							<Route path="/Home/master/siso_Excel_Upload" element={<SISO_EXCELUPLOAD />} /> 
							<Route path="/Home/master/siso_Image_Status_Update" element={<SISO_ImageStatusUpdate />} /> 
							<Route path="/Home/master/siso_MaterialCodes_Excel_Upload" element={<SISO_EXCELUPLOAD_MATERIAL />} />
							<Route path="/Home/master/siso_Material_Image_Status_Update" element={<SISO_ImageStatusUpdate_MATERIAL />} />
							<Route path="/ProductDetails_INLUDE" element={<ProductDetails_INLUDE />} />
							
							
				<Route path="/Home/Dealer/Dealerdevelopmentplan" element={<Dealerdevelopmentplan />} />
                          <Route path="/Home/Approval/MDP_Approval" element={<MdpApproval />} />
                          <Route path="/Home/Dealer/MDP_Completion" element={<MdpCompletion />} />
                     
						  <Route path="/home/Reports/Balance_Confirmation_Report" element={<BalanceConfirmation />} />
							  <Route path="/home/Solar/Solar_Project_ID_Creation" element={<Solarempcreate />} />
						  <Route path="/home/Solar/Solar_Customer_Creation" element={<SolarCustomerCreation />} />
						      <Route path="/home/Reports/Product_Registration_Report" element={<Product_Registration_Report />} />
							   <Route path="/home/Solar/Solar_Order_Creation" element={<Solar_Order_creation />} />
                               <Route path="/home/Master/Dealer_Status_Control" element={<Dealer_Status_Control/>}/>
                               {/* <Route path="/" element={<Dealer_Status_Control/>}/> */}
                              
                               <Route path="/home/Master/Global_Billing_Minimum_Order_Value_Config" element={<Global_Billing_Minimum_Value_Order_Config/>}/>
							   
							   
							   <Route path="/home/Reports/dealer_map_view" element={<DealerMapView />} />
							   <Route path="/home/Reports/dealer_region_map_view" element={<DealerRegionMapView />} />
                               
                               <Route path="/home/Reports/Service_Complaint_Spares_Report" element={<SCAReprot/>}/>
                         <Route path="/home/Reports/Mediators_Report" element={<Mediator_Report/>}/>
                         <Route path="/home/Reports/DDP_Document_Download" element={<DDP_Document_Download />} />
						  <Route path="/home/Reports/Spares_And_Labour_Report" element={<Spares_And_Labour_Report />} />
						  <Route path="/home/Reports/Service_Claim_Report" element={<New_SC_Report/>}/>
						  <Route path="/home/Reports/Service_Claim_Duplicate_Invoice_Copy" element={<Newserviceclaiminvoicecopy/>} />
						  <Route path="/home/Reports/Service_Claim_Report_HOF" element={<ServiceClaimReport/>}/>
						  <Route path="/home/Reports/Service_dashbord" element={<ServiceDashborde/>}/>
						  <Route path="/home/Reports/product_registration_status" element={<ProductRegistrationStatus/>}/>
                          
						  
						   <Route path="/home/services/Rewinding_Rate_Fixation" element={<Rewinding_Rate_Fixation />} />
                          <Route path="/home/services/Rewinding_Rate_Approval" element={<Rewinding_Rate_Approval />} />

                          <Route path="/home/Reports/Retailer_Report" element={<Retailer_Report />} />
                          <Route path="/home/Reports/Retailer_Report_Excel_Download" element={<Retailer_Report_Excel_Download />} />
                          <Route path="/home/Reports/Bandhan_Report" element={<Bandhan_Report />} />
                          <Route path="/home/Reports/Mechanic_Report" element={<Mechanic_Report />} />
                          <Route path="/home/Reports/Mechanic_Report_Excel_Download" element={<Mechanic_Report_Excel_Download />} />
                          <Route path="/home/Service/Service_Call_Cancellation" element={<Service_Call_Cancellation/>}/>
                          <Route path="/home/Service/Service_Call_Cancellation_Status" element={<Service_Call_Cacellation_Status/>}/>
                          <Route path="/home/Service/Warrenty_Cancel" element={<Warrenty_Cancel/>}/>
                          <Route path="/home/Service/Warrenty_Status" element={<Warrenty_Status/>}/>
                          <Route path="/home/Service/Post_Warrenty_Status" element={<Post_Warrenty_Status/>}/>
                          <Route path="/home/Service/Service_Claim_Cancel" element={<Service_Claim_Cancel/>}/>
                          <Route path="/home/Service/Service_Claim_Ledger" element={<Service_Claim_Ledger/>}/>
                          <Route path="/home/Approval/Service_Call_Cancellation_Approval" element={<Service_Call_Cancellation_Approval/>}/>
                          <Route path="/home/Service/Asc_Segment_Config" element={<Asc_Segment_Config/>}/>
                          <Route path="/home/Service/Asc_Mapping" element={<Asc_Mapping/>}/>
                          <Route path="/home/Service/Un_Mapped_Dealers" element={<Un_Mapped_Dealers/>}/>
                           <Route path="/home/Master/PSG_vs_Billing_Group_Mapping" element={<PGVSBG/>}/>
                           <Route path="/home/Services/Billing_Claim_Print" element={<Billing_Claim_Print/>}/>
						   
						   <Route path="/home/Reports/retailer_sales_report" element={<RetailerSalesOrderReport/>}/>
						            <Route path="/home/Approval/BCS_HO_Approval" element={<BCS_HO_Approval/>}/>
                           <Route path="/home/Reports/BCS_Orders_Report" element={<BcsOrderStatus/>}/>
                             <Route path ="/home/Services/Bcs_Winding_Config" element={<Bcs_Winding_Config/>}/>
                             <Route path ="/home/Dealer/BCS_Approval_Mapping" element={<BCS_Approval_Mapping/>}/>

                            <Route path="/home/Reports/dealer_and_subdealer" element={<DealerAndSubDealerReport />} />
							
							<Route path ="/Home/Tools/Scheme_Create" element={<SchemeCreate/>}/>
														
							<Route path ="/Home/Services/Replacement" element={<Replacement/>}/>
							<Route path ="/Home/Reports/Replacement_Report" element={<ReplacementReport/>}/>
                        </Routes>
                    </div>
                </BreadcrumbsContext.Provider> 
            </Router>
        </div>
    );
};

export default App;
